export default "__VITE_ASSET__DZD$_Ydh__"